import React, { Component } from 'react'

import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import ContMessageI18N from '../../containers/ContMessageI18N';
import SliderTooltip from './SliderTooltip';

const VAR_BS_PRIMARY = 'var(--bs-primary)'

const styles = {
	sliderTextStyle: {
		color: VAR_BS_PRIMARY, fontWeight: 'bold',
		fontSize: '10pt',
		whiteSpace: "nowrap"
	},
	sliderTrackStyle: { backgroundColor: 'var(--bs-info)' },
	sliderDotStyle: { borderColor: VAR_BS_PRIMARY },
	sliderHandleStyle: {
		borderColor: VAR_BS_PRIMARY,
		backgroundColor: VAR_BS_PRIMARY,
		width: '8px',
		marginLeft: '-4px',
		borderRadius: 0
	},
};

class SliderCriteria extends Component {

	constructor(props) {
		super(props);
		this.onChange = props.onChange;
		this.state = SliderCriteria.getStateFromProps(props);
	}
	handleChange = function (data, component) {
		component.props.onChange(data);
		component.setState({ "value": data });
	}

	static getMessage(i18nKey, arg, argType) { return <ContMessageI18N i18n={i18nKey} arg={arg} argType={argType} /> }

	static getStateFromProps(props) {
		var valMin = null;
		var valMax = null;
		var valueLabels = {};
		if (props.min != null && props.max != null && props.step != null && props.step !== 0.0 && (props.min % props.step === 0)) {
			return SliderCriteria.getStateFromPropsWithMinMaxStep(props);
		} else if (props.values != null) {
			return SliderCriteria.getStateFromPropsWithValues(props);
		} else if (props.min != null && props.max != null) {
			return SliderCriteria.getStateFromPropsWithMinMax(props);
		}
		return {
			defmin: props.min,
			defmax: props.max,
			defstep: props.step,
			value: props.value,
			contextMin: props.contextMin,
			contextMax: props.contextMax,
			valMin: valMin,
			valMax: valMax,
			valueLabels: valueLabels
		}
	}

	static getStateFromPropsWithMinMaxStep(props) {
		var valMin = null;
		var valMax = null;
		var valueLabels = {};
		var textStyle = styles.sliderTextStyle;
		for (var i = props.min; i <= props.max; i += props.step) {
			if ((props.contextMin == null || props.contextMin <= i) && (props.contextMax == null || props.contextMax >= i)) {
				valMax = i;
				if (valMin === null) {
					valMin = i;
				}
			}
		}
		for (var val = valMin; val <= valMax; val += props.step) {
			var texte;
			if (props.i18nKey != null && props.i18nArgType != null) {
				texte = SliderCriteria.getMessage(props.i18nKey, val, props.i18nArgType);
			} else {
				texte = `${val} ${props.unit}`;
			}
			valueLabels[val] = { style: textStyle, label: texte };
		}
		return {
			defmin: props.min,
			defmax: props.max,
			defstep: props.step,
			value: props.value,
			contextMin: props.contextMin,
			contextMax: props.contextMax,
			valMin: valMin,
			valMax: valMax,
			valueLabels: valueLabels
		}
	}

	static getStateFromPropsWithValues(props) {
		var valMin = null;
		var valMax = null;
		var valueLabels = {};
		var textStyle = styles.sliderTextStyle;
		var textStyleNone = { display: 'none' };
		valMin = Math.min(...props.values);
		valMax = Math.max(...props.values);
		for (var valKey in props.values) {
			var val2 = props.values[valKey];
			var texte2 = '.';
			if (props.values.length < 6) {
				if (props.i18nKey != null && props.i18nArgType != null) {
					texte2 = SliderCriteria.getMessage(props.i18nKey, val2, props.i18nArgType);
				} else {
					texte2 = `${val2} ${props.unit}`;
				}
			}
			const style = props.values.length < 6 ? textStyle : textStyleNone;
			valueLabels[val2] = { style: style, label: texte2 };
		}
		return {
			defmin: props.min,
			defmax: props.max,
			defstep: props.step,
			value: props.value,
			contextMin: props.contextMin,
			contextMax: props.contextMax,
			valMin: valMin,
			valMax: valMax,
			valueLabels: valueLabels
		}
	}

	static getStateFromPropsWithMinMax(props) {
		var valMin = null;
		var valMax = null;
		var valueLabels = {};
		var textStyle = styles.sliderTextStyle;

		valMin = props.min;
		valMax = props.max;
		var values = [props.min, props.max];
		for (var valKey3 in values) {
			var val3 = values[valKey3];
			var texte3;
			if (props.i18nKey != null && props.i18nArgType != null) {
				texte3 = SliderCriteria.getMessage(props.i18nKey, val3, props.i18nArgType);
			} else {
				texte3 = `${val3} ${props.unit}`;
			}
			valueLabels[val3] = { style: textStyle, label: texte3 };
		}

		return {
			defmin: props.min,
			defmax: props.max,
			defstep: props.step,
			value: props.value,
			contextMin: props.contextMin,
			contextMax: props.contextMax,
			valMin: valMin,
			valMax: valMax,
			valueLabels: valueLabels
		}
	}

	static getDerivedStateFromProps(props, currentState) {
		if (currentState.contextMin !== props.contextMin
			|| currentState.contextMax !== props.contextMax
			|| currentState.defmin !== props.min
			|| currentState.defmax !== props.max
			|| currentState.defstep !== props.step
			|| currentState.value !== props.value
		) {
			return SliderCriteria.getStateFromProps(props);
		}
		return null
	}

	render() {
		let step = null;
		if (this.props.step !== 0.0 && this.props.step !== undefined && this.props.step > this.props.minStep) {
			step = this.props.step;
		} else if (this.props.minStep !== 0.0 && this.props.minStep !== undefined) {
			step = this.props.minStep;
		}
		return (
			<div className="container text-center" style={{ minHeight: '50px', marginTop: '20px' }}>
				<Slider
					value={this.state.value}
					min={this.state.valMin}
					max={this.state.valMax}
					step={step}
					onChange={(data) => { this.handleChange(data, this) }}
					marks={this.state.valueLabels}
					styles={{
						track: styles.sliderTrackStyle,
						handle: styles.sliderHandleStyle
					}}
					dotStyle={styles.sliderDotStyle}
					activeDotStyle={styles.sliderDotStyle}
					handleRender={(node, handleProps) => {
						// Filter out invalid DOM props from rc-slider
						const { prefixCls, dragging, draggingDelete, ...validProps } = handleProps;
						return (
							<div {...validProps} style={{ ...validProps.style, position: 'relative' }}>
								<SliderTooltip >
									{SliderCriteria.getMessage(this.props.i18nKey, this.state.value, this.props.i18nArgType)}
								</SliderTooltip>
								{node}
							</div>
						);
					}}
				/>
			</div>
		)
	}
}

export default (SliderCriteria)
